import React, {useContext, useEffect} from "react";
import {useDispatch} from 'react-redux'
import PropTypes from "prop-types"

import {ORDER_TYPE_PENDING, useStoreExecutions} from "../../../store/useStoreExecutions";
import AuthContext from "../../../contexts/AuthContext";
import TableCustom from "../../ui/table/TableCustom";
import ModalCustom from "../../ui/modal/ModalCustom";
import {useActionsButtons} from "../../../hooks/executions/useActionsButtons";
import ShopperModals from "../../ui/modal/ShopperModals";
import Loader from "../../ui/loader/Loader";
import {base64} from '../../../Tools/Tools'
import {configureShoppersModals} from '../../../slice/shoppersModalsSlice'
import {
    useShopperPrebook,
} from '../../../hooks/useShoppers'

export const ExecutionsTab = ({defaultType}) => {
    const {user} = useContext(AuthContext);
    const dispatch = useDispatch();
    const storeExecutions = useStoreExecutions();
    const getExecutions = useStoreExecutions((state) => state.getExecutions);
    const executions = useStoreExecutions(state => state.executions);
    const executionsInProgress = useStoreExecutions(state => state.executionsInProgress);
    const isLoading = useStoreExecutions(state => state.isLoading);
    const isError = useStoreExecutions(state => state.isError);
    const sortType = useStoreExecutions(state => state.sortType);
    const sortOrder = useStoreExecutions(state => state.sortOrder);
    const type = useStoreExecutions(state => state.type);
    const setType = useStoreExecutions(state => state.setType);

    const {
        actionButtons,
        handleShowOrder,
        showModalInformation,
        modalSize,
        modalTitle,
        modalContent,
        modalBodyClass,
        modalFooter,
        buttons,
        setShowModalInformation,
        handleCancellationModal
    } = useActionsButtons();

    const {displayShopperContactOnExec} = useShopperPrebook(user)

    useEffect(() => {
        if (defaultType && type !== defaultType) {
            setType(defaultType);
        }
    }, [defaultType, type, setType]);

    // Permet de charger une première fois les données avec Zustand
    useEffect(() => {
        getExecutions(user, true);
    }, [type, user]);

    useEffect(() => {
        const execsAll = [...executions, ...executionsInProgress];

        if (execsAll.length) {
            const chosenPrebooks = {}

            execsAll.forEach((execution) => {
                if (execution.prebook?.mission) {
                    chosenPrebooks[base64(execution.prebook.id)] = execution.prebook
                }
            })

            dispatch(configureShoppersModals({chosenPrebooks}))
        }
    }, [executions, executionsInProgress])

    const handleSortOrder = (newSortType) => {
        let sort = sortOrder === 'asc' ? 'desc' : 'asc';

        if (newSortType !== sortType) {
            sort = 'asc';
        }
        storeExecutions.sortOrder = sort;
        storeExecutions.sortType = newSortType;
        getExecutions(user, true);
    }

    return (
        <>
            <TableCustom
                id={'executionsList'}
                isLoading={isLoading}
                isError={isError}
                headers={[
                    'Etat',
                    'Numéro',
                    'Date et moment de livraison',
                    'Code postal ville',
                    'Accessoire',
                    'Montant',
                    'Actions',
                ]}
                sorting={[
                    'etatextranet',
                    'numcde',
                    'datliv',
                    'localite',
                    'occasion',
                    'montantcdee',
                ]}
                handleSortOrder={handleSortOrder}
                data={type === ORDER_TYPE_PENDING ? executionsInProgress : executions}
                sortType={sortType}
                sortOrder={sortOrder}
                configLine={
                    {
                        key: 'etatextranet',
                        filter: 40,
                        color: 'blue-light',
                        text_class: 'font-weight-bold',
                    }
                }
                config={[
                    {
                        type: 'picto',
                        key: 'etatextranet',
                        appendTitle: (stateId, order) => displayShopperContactOnExec(stateId, order)
                    },
                    {
                        type: 'multilines',
                        key: [
                            {
                                type: 'link_modal_order',
                                key: 'numcde',
                                func: handleShowOrder,
                                funcParam: 'numcde',
                            },
                            {type: 'text', key: 'nomdes'},
                        ],
                    },
                    {
                        type: 'multilines',
                        key: [
                            {type: 'date', key: 'datliv'},
                            {type: 'text', key: 'momentjourvalue'},
                        ],
                    },
                    {
                        type: 'multilines',
                        key: [
                            {type: 'locality', key: 'codpostal'},
                            {type: 'locality', key: 'localite'},
                            {type: 'drive', key: 'drive'},
                        ],
                    },
                    {
                        type: 'list',
                        key: 'accessories',
                        labelField: 'accessory_label',
                        quantityField: 'accessory_number',
                        compactList: true,
                        withQuantity: true,
                    },
                    {type: 'currency', key: 'amountvat'},
                    {
                        type: 'buttons',
                        key: actionButtons,
                    },
                ]}
            />

            {isLoading && <Loader />}

            <ModalCustom
                show={showModalInformation}
                id={'executions-modal'}
                onHide={() => setShowModalInformation(false)}
                size={modalSize}
                title={modalTitle}
                titleClassname={modalTitle ? 'px-3 pb-2' : 'text-center mb-3'}
                header={false}
                bodyClassname={modalBodyClass}
                content={
                    <>
                        {modalContent}
                    </>
                }
                footer={modalFooter}
                buttonsFooter={[
                    ...buttons,
                    ...[
                        {
                            text: 'Fermer',
                        },
                    ],
                ]}
            />

            <ShopperModals
                handleCancellationModal={handleCancellationModal}
                executions={type === ORDER_TYPE_PENDING ? executionsInProgress : executions}
            />
        </>
    );
}

ExecutionsTab.propTypes = {
    defaultType: PropTypes.string,
};
